import { Button } from "@mui/material";
import { AddPhotoAlternate, RemoveCircle } from "@mui/icons-material";
import ImageUploading from "react-images-uploading";

const Buttons = ({
  isDragging,
  onImageUpload,
  dragProps,
  images,
  onImageRemoveAll,
}) => {
  return (
    <div className="w-full flex items-center gap-4">
      <Button
        size="small"
        startIcon={<AddPhotoAlternate />}
        variant="outlined"
        sx={{ color: isDragging ? "red" : null }}
        onClick={onImageUpload}
        {...dragProps}
        lang="tr"
      >
        Ürün Görselleri Yükle
      </Button>
      {images.length > 0 && (
        <Button
          size="small"
          startIcon={<RemoveCircle />}
          variant="outlined"
          onClick={onImageRemoveAll}
          lang="tr"
        >
          Tüm Görselleri Kaldır
        </Button>
      )}
    </div>
  );
};

const ImageList = ({
  imageList,
  onImageRemove,
  handleSelectCoverImage,
}) => {
  const ActionsButtons = ({
    i,
    isCover,
    handleSelectCoverImage,
  }) => {
    return (
      <div className="actions-buttons">
        <button
          className="first-photo"
          type="button"
          onClick={() => handleSelectCoverImage(i)}
        >
          {true === isCover && <span> (Kapak Olarak Seçildi)</span>}
          {true !== isCover && <span> (Kapak Yap)</span>}
        </button>
        <div className="btn-bottom">
          <button
            className="remove-photo"
            type="button"
            onClick={() => onImageRemove(i)}
          >
            Kaldır
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="uploaded-images-area">
      <ul>
        {imageList.map((image, i) => (
          <li key={i}>
            <div className="image">
              <img src={image.data_url} alt="" />
            </div>
            <ActionsButtons
              i={i}
              id={image.id}
              isCover={image.cover}
              handleSelectCoverImage={handleSelectCoverImage}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

const ProductImages = ({
  images,
  onChangeImages,
  coverImageIndex,
  handleSelectCoverImage,
}) => {
  return (
    <div className="w-full mt-4">
      <ImageUploading
        multiple={true}
        value={images}
        onChange={onChangeImages}
        dataURLKey="data_url"
        acceptType={["jpg", "png", "webp", "jpeg", "webp"]}
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          <div className="w-full block">
            <Buttons
              isDragging={isDragging}
              onImageUpload={onImageUpload}
              dragProps={dragProps}
              images={images}
              onImageRemoveAll={onImageRemoveAll}
            />
            <ImageList
              imageList={imageList}
              onImageUpdate={onImageUpdate}
              onImageRemove={onImageRemove}
              coverImageIndex={coverImageIndex}
              handleSelectCoverImage={handleSelectCoverImage}
            />
          </div>
        )}
      </ImageUploading>
    </div>
  );
};

export default ProductImages;
